import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Dialog from '@mui/material/Dialog';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, updateData, SyncData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save'; // Import the Save icon
import EditNoteIcon from '@mui/icons-material/EditNote';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Select from 'react-select';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import PrintIcon from '@mui/icons-material/Print';
import BillPrint from './Bill';


function PROIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [editedRouteSequenceNo, setEditedRouteSequenceNo] = useState(null);
    const [orderdate, setOrderdate] = useState("");
    const [editItemId, setEditItemId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    // const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [formData, setFormData] = useState();
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchRouteTypes();
    }, []);

    const fetchRouteTypes = async () => {
        try {
            const response = await fetchData('RouteApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(route => ({
                    value: route.id,
                    label: route.name
                }));
                setRouteOptions(options);

            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const [filteredData, setFilteredData] = useState([]);
    const handleRouteTypeChange = async (selectedOption) => {
        setSelectedRoute(selectedOption);

        try {
            const response = await fetchData('PROSaleOrderApi', `/${companyId}/${selectedOption.value}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
                // Update filtered data here
                setFilteredData(response.response_data.filter(item =>
                    (selectedOption ? item.route === selectedOption.value : true)
                ));
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
        }
    };



    const handleDelete = async () => {
        deleteData('CustomerApi', `${deleteItemId}`, token)
            .then((response) => {
                //fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };


    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const handleSaleOrderPrint = async (SaleOrderid) => {
        try {
            // Fetch data
            const response = await fetchData('PROSaleOrderApi', `/PROSaleorderPrint/${SaleOrderid}`, token);
            const labelData = Array.isArray(response.response_data) ? response.response_data : [response.response_data];

            // Create iframe
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            // Write component content to iframe
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            // Render BillPrint component inside iframe
            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();

            // Print the content
            iframe.contentWindow.print();


            try {
                await SyncData('SaleOrderApi', `${SaleOrderid}`, token);
            } catch (updateError) {
                console.error('Error updating record:', updateError);
            }
        } catch (error) {
            console.error('Error printing Estimate:', error);
        }
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">
            <div className='w-full mb-2 flex'>
                <h4 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bolder' }}>PRO.SaleOrder</h4>
                <div className="w-1/4 mr-2">
                    <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code">
                        Route
                    </label>
                    <Select
                        value={selectedRoute}
                        onChange={handleRouteTypeChange}
                        options={routeOptions}
                        placeholder="Select Route"
                        isSearchable
                    />
                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '600px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#008080' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '50px' }}>R.SequenceNo</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', textAlign: 'left' }}>Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>Contact No</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>L.BillDate</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>L.BillAmount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>L.Outstanding</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>OrderDate</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>ItemCount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>Amount</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>Actions</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: 'rgba(38, 166, 154, 0.3)' }}>
                            {data.map((item, index) => (
                                <TableRow key={item.id} className="size">
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bolder', padding: '2px', width: '50px', textAlign: 'center' }}>{item.routeSequenceNo}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bolder', padding: '2px' }}>{item.name}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'black', fontWeight: 'bolder', padding: '2px', fontSize: '16px' }}>{item.contactNumber1} , {item.contactNumber2} </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'orangered', fontWeight: 'bolder', padding: '2px' }}></TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'orangered', fontWeight: 'bolder', padding: '2px' }}></TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'orangered', fontWeight: 'bolder', padding: '2px' }}></TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'orangered', fontWeight: 'bolder', padding: '2px' }}>{item.orderDate && new Date(item.orderDate).toLocaleDateString('en-GB')}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'orangered', fontWeight: 'bolder', padding: '2px' }}>{item.itemcount}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'brown', fontWeight: 'bolder', padding: '2px' }}>
                                        {item.totalamount}
                                    </TableCell>
                                    <TableCell>
                                        {item.saleorderfinish === false && (
                                            <Tooltip title="Edit the PRO.Saleorder">
                                                <Link to={`/PSaleOrderEdit/${item.saleorderid}`}>
                                                    <IconButton>
                                                        <EditIcon style={{ color: 'blueviolet' }} />
                                                    </IconButton>
                                                </Link>
                                            </Tooltip>
                                        )}
                                    </TableCell>
                                    <TableCell>

                                        {item.saleorderfinish === true ? (
                                            <Link to={`/PROSaleOrderCreate/${item.id}`}>
                                                <Tooltip title="Create PRO-Sale Order">
                                                    <IconButton>
                                                        <ArrowForward style={{ color: 'darkgoldenrod', fontWeight: 'bold' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </Link>
                                        ) : (

                                            <Tooltip title="Generate the PRO.Saleorder Bill">
                                                <Button onClick={() => handleSaleOrderPrint(item.saleorderid)} style={{ backgroundColor: 'brown', color: "whitesmoke", fontWeight: 'bolder' }}>
                                                    Generate Bill
                                                </Button>
                                            </Tooltip>
                                        )}
                                    </TableCell>


                                </TableRow>
                            ))}
                        </TableBody>


                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>
                        </Dialog>
                    </Table>
                </TableContainer>
            </div >
        </div >
    );
}

export default PROIndex;

